/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SdkErrorModel } from '../../models/sdk-error-model';

export interface ScanSdkErrorPost$Params {
      body?: SdkErrorModel
}

export function scanSdkErrorPost(http: HttpClient, rootUrl: string, params?: ScanSdkErrorPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, scanSdkErrorPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as VivaLiteScanStrictHttpResponse<void>;
    })
  );
}

scanSdkErrorPost.PATH = '/Scan/SDKError';
